interface ValidateValue {
  value: unknown;
  allowedTypes: string[];
}

export const validateMessageData = (validateValue: ValidateValue): boolean => {
  const { value, allowedTypes } = validateValue;

  const type = typeof value;

  if (allowedTypes.includes(type)) {
    return true;
  }

  return false;
};
